import React, { useEffect, useState } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function AdminInternshipPage() {
  const [internships, setInternships] = useState([]);
  const [form, setForm] = useState({
    title: '',
    technologies: '',
    duration: '',
    eligibility: ''
  });

  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      toast.error('Please login first');
      navigate('/admin');
    } else {
      fetchInternships();
    }
  }, [token, navigate]);

  const fetchInternships = async () => {
    try {
      const res = await api.get('/internships');
      setInternships(res.data);
    } catch (err) {
      toast.error('Failed to load internships');
    }
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await api.post('/internships', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Internship added');
      setForm({ title: '', technologies: '', duration: '', eligibility: '' });
      fetchInternships();
    } catch (err) {
      toast.error('Add failed');
    }
  };

  const handleDelete = async id => {
    if (!window.confirm('Delete this internship?')) return;
    try {
      await api.delete(`/internships/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Internship deleted');
      fetchInternships();
    } catch (err) {
      toast.error('Delete failed');
    }
  };

  return (
    <div className="container py-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Manage Internships</h3><button onClick={() => navigate('/admin/dashboard')} className="btn btn-outline-primary btn-sm">
      ← Dashboard
    </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={() => {
            localStorage.removeItem('token');
            navigate('/admin');
          }}
        >
          Logout
        </button>
      </div>

      <form onSubmit={handleSubmit} className="mb-4">
        <div className="row g-2">
          <div className="col-md-3">
            <input
              name="title"
              className="form-control"
              placeholder="Internship Title"
              value={form.title}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-3">
            <input
              name="technologies"
              className="form-control"
              placeholder="Technologies (comma-separated)"
              value={form.technologies}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-3">
            <input
              name="duration"
              className="form-control"
              placeholder="Duration (e.g. 2 months)"
              value={form.duration}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-3">
            <input
              name="eligibility"
              className="form-control"
              placeholder="Eligibility"
              value={form.eligibility}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <button type="submit" className="btn btn-dark mt-3">Add Internship</button>
      </form>

      <div className="row">
        {internships.map(item => (
          <div className="col-md-6 mb-4" key={item.id}>
            <div className="card shadow-sm">
              <div className="card-body">
                <h5>{item.title}</h5>
                <p><strong>Tech:</strong> {item.technologies}</p>
                <p><strong>Duration:</strong> {item.duration}</p>
                <p><strong>Eligibility:</strong> {item.eligibility}</p>
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(item.id)}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
